/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Review_Pro5Inputs */

const en_fc_home_review_pro5 = /** @type {(inputs: Fc_Home_Review_Pro5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every action can be scripted through a CLI, a JSON channel or an MCP server.`)
};

/**
* | output |
* | --- |
* | "Every action can be scripted through a CLI, a JSON channel or an MCP server." |
*
* @param {Fc_Home_Review_Pro5Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_review_pro5 = /** @type {((inputs?: Fc_Home_Review_Pro5Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Review_Pro5Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_review_pro5(inputs)
});
export { fc_home_review_pro5 as "fc.home.review.pro5" }